
import { Theme, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import Tooltip from '../atoms/Tooltip';
import ArrowUpIcon from '../icons/ArrowUpIcon';
import ArrowUpCircleIcon from '../icons/ArrowUpCircleIcon';
import { COLOR_RED } from '../styles/colors';
import { datetimeToDate, formatNumbersToCommaSeparatedString } from '../services/converter';
import clsx from 'clsx';
import { PlayerNILValues } from '../types/PlayerNILValues';
import { formatValueInK } from '../services/user';

interface NilValuesTooltipProps {
  playerNilValues?: PlayerNILValues[];
  nilIndicatorClassName?: string;
  on3PublicNILValuation?: number | null | string;
  valuationTextClassName?: string;
  valuationTextStyle?: React.CSSProperties;
  formatAmount?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  nilTooltipWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    whiteSpace: 'nowrap',
  },
  nilHistoryIndicator: {
    height: '24px',
    width: '24px',
    position: 'relative',
    left: '1px',
    '& svg': {
      display: 'block',
    },
  },
  nilListItem: {
    fontSize: '14px',

    '& span': {
      display: 'inline-block',
      textAlign: 'right',
      width: '70px',
    },
  },
  danger: {
    color: COLOR_RED,
  },
}));

export default function NilValuesTooltip(props: NilValuesTooltipProps) {
  const {
    playerNilValues,
    nilIndicatorClassName,
    on3PublicNILValuation,
    valuationTextClassName,
    valuationTextStyle,
    formatAmount = true,
  } = props;
  const sortedNilData = playerNilValues?.length
  ? [...playerNilValues].sort(
      (a, b) => new Date(b.on3Date).getTime() - new Date(a.on3Date).getTime()
    )
  : [];
  const classes = useStyles();

  const NilDataList = () => {
    return (
      <div>
        {sortedNilData.map((item, index) => {
          const prevValue = index >= 0 ? (sortedNilData[index]?.on3PublicNILValuation < sortedNilData[index + 1]?.on3PublicNILValuation) : false;

          return (
            <Typography key={index} className={clsx(classes.nilListItem, prevValue && classes.danger )}>
              <span>{item.on3PublicNILValuation.toLocaleString()}</span>: {!!item?.on3Date && datetimeToDate(item.on3Date)}
            </Typography>
          )
        })}
      </div>
    );
  };

  {/* <ArrowUpIcon className={clsx(classes.nilHistoryIndicator, nilIndicatorClassName)} /> */}
  return (
    <div className={classes.nilTooltipWrapper}>
      {on3PublicNILValuation && (
        <span className={valuationTextClassName} style={valuationTextStyle}>${formatAmount ? formatValueInK(Number(on3PublicNILValuation || 0)) : formatNumbersToCommaSeparatedString(Number(on3PublicNILValuation || 0))}</span>
      )}
          <Tooltip title={playerNilValues?.length ? NilDataList() : ''}>
              <ArrowUpCircleIcon className={clsx(classes.nilHistoryIndicator, nilIndicatorClassName)} />
          </Tooltip>
    </div>
  )
}
